import {Component, OnInit} from '@angular/core';
import {ComponentAsElement} from '../../services/common/bootstrap/annotation/component-as-element';
import {GMapService} from "../../services/g-map.service";
import {LatLng, Pos} from "../../model/PosModel";

@ComponentAsElement('v-list-of-salons-element')
@Component({
  selector: 'v-list-of-salons',
  templateUrl: './list-of-salons.component.html',
  styleUrls: []
})
export class ListOfSalonsComponent implements OnInit {
  poses: (Pos|null)[] = [];
  selectedCity: null|string = null;
  selectedPoses = [];
  currentLocation : null|LatLng = null;
  filterBy;
  distanceLimit = 50;
  showList = false;

  constructor(private gMapService: GMapService) {
  }

  ngOnInit() {
    this.getPoses();
    this.gMapService.currentCity.subscribe(_city => {
      this.showList = false;
      this.selectedCity = _city;
      this.selectedPoses = [];
      this.filterBy = this.selectedCity;
      setTimeout(() => {
        this.showList = true;
      }, 200);
    });
    this.gMapService.currentLocation.subscribe(_location => {
      this.currentLocation = _location;
      if(this.currentLocation && this.poses) {
        this.calculateDistance()
      }
    });
  }

  private getPoses() {
    this.gMapService.poses.subscribe( items => {
      items.forEach( (item: Pos) => {
        this.poses.push(item);
      });
      this.poses.sort();
      this.showList = true;
    });
  }

  private calculateDistance() {
    const geo = new google.maps.LatLng(this.currentLocation.lat, this.currentLocation.lng);
    let tempPoses = [];

    this.selectedPoses = [];
    this.selectedCity = null;
    this.showList = false;
    this.poses.forEach((pos: Pos) => {
      const city = new google.maps.LatLng(pos.latitude, pos.longitude);
      const distance = (google.maps.geometry.spherical.computeDistanceBetween(geo, city)/1000).toFixed();
      if(parseFloat(distance) < this.distanceLimit){
        tempPoses.push({'name':pos.name, 'distance': parseFloat(distance)});
      }
      this.filterBy = this.selectedPoses;
      setTimeout(() => {
        this.showList = true;
      }, 200);
    });
    tempPoses.sort((a, b) => (a.distance > b.distance) ? 1 : -1);
    tempPoses.forEach(pos => {
      this.selectedPoses.push(pos.name);
    });
  }
}
